import React from 'react'
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material'

const Imprint: React.FC = () => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Impressum</Typography>
      <Typography variant='subtitle1'>Angaben gem&auml;&szlig; &sect; 5 TMG</Typography>

      <Typography variant='body1'>Kristin Dietze<br />
        Maxim-Gorki-Str. 7a<br />
        01445 Radebeul
      </Typography>
      <Typography variant='subtitle1'>Kontakt</Typography>
      <Typography variant='body1'>Telefon: +49 (0) 172 61 94 173<br />
        E-Mail: kristinkatrindietze@gmail.com
      </Typography>
      <Typography variant='subtitle1'>Haftungshinweis</Typography>
      <Typography variant='body1'>
        Für die Richtigkeit und Vollständigkeit der hier dargestellten Inhalte kann keine Haftung übernommen
        werden.
        Insbesondere kann keine Haftung übernommen werden bei Internetangeboten, auf die diese Seiten verweisen,
        die
        jedoch nicht in unserem Verantwortungsbereich liegen. Für weitere Informationen lesen Sie bitte den
        Disclaimer/Haftungsausschluss.
      </Typography>
      <Typography variant='subtitle1'>Disclaimer/Haftungsausschluss</Typography>
      <Typography variant='body1'>
        1. Inhalt des Onlineangebotes<br />
        Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der
        bereitgestellten Informationen. Haftungsansprüche gegen den Autor, die sich auf Schäden materieller oder
        ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch
        die
        Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich
        ausgeschlossen,
        sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden
        vorliegt.Alle
        Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der
        Seiten oder
        das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die
        Veröffentlichung
        zeitweise oder endgültig einzustellen.<br /><br />
        2. Verweise und Links<br />
        Bei direkten oder indirekten Verweisen auf fremde Internetseiten ("Links"), die außerhalb des
        Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall
        in Kraft
        treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre,
        die
        Nutzung im Falle rechtswidriger Inhalte zu verhindern.Der Autor erklärt hiermit ausdrücklich, dass zum
        Zeitpunkt
        der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle
        und
        zukünftige Gestaltung, die Inhalte oder die Urheberschaft der gelinkten/verknüpften Seiten hat der Autor
        keinerlei Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller
        gelinkten/verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese Feststellung gilt für
        alle
        innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom
        Autor
        eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder
        unvollständige
        Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener
        Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht
        derjenige, der
        über Links auf die jeweilige Veröffentlichung lediglich verweist.<br /><br />
        3. Urheber- und Kennzeichenrecht<br />
        Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente,
        Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen
        und Texte
        zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen.
        Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und
        Warenzeichen
        unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den
        Besitzrechten der
        jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen,
        dass
        Markenzeichen nicht durch Rechte Dritter geschützt sind!
        Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der
        Seiten. Eine
        Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen
        elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht
        gestattet.
      </Typography>
    </Paper>
  )
}

export default Imprint
